
import { useState, useEffect } from 'react';
import { Timer } from 'lucide-react';
import { cn } from '@/lib/utils';

interface TaskCountdownProps {
  dueDate: string | null;
  className?: string;
}

export const TaskCountdown = ({ dueDate, className }: TaskCountdownProps) => {
  if (!dueDate) return null;

  const calculateRemainingTime = () => {
    const difference = new Date(dueDate).getTime() - new Date().getTime();
    let remaining = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };

    if (difference > 0) {
      remaining = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return { remaining, isOver: difference <= 0 };
  };

  const [{ remaining, isOver }, setTime] = useState(calculateRemainingTime());

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(calculateRemainingTime());
    }, 1000);

    return () => clearInterval(timer);
  }, [dueDate]);

  if (isOver) {
    return <span className={cn("text-red-600 font-semibold text-xs", className)}>انتهى الوقت</span>;
  }

  const { days, hours, minutes, seconds } = remaining;
  
  let colorClass = 'text-green-600';
  if (days < 1) {
    if (hours < 1) {
      colorClass = 'text-red-600 animate-pulse';
    } else if (hours < 12) {
      colorClass = 'text-orange-500';
    }
  }

  return (
    <div className={cn('flex items-center gap-1 font-mono text-xs font-semibold', colorClass, className)}>
        <Timer className="w-3 h-3"/>
        <span>
            {days > 0 && `${days}ي `}
            {`${String(hours).padStart(2, '0')}:`}
            {`${String(minutes).padStart(2, '0')}:`}
            {`${String(seconds).padStart(2, '0')}`}
        </span>
    </div>
  );
};
